import axios from "axios";
import { decrypt, encrypt } from "./cryptoService";
import { IS_DATA_ENCRYPTED, PARTNER_AK_VALUE, CPR_AK_VALUE, FAF_AK_VALUE, CASE_AK_VALUE, BASE_URL, BASE_AZURE_URL, CPR_BASE_URL, FAF_BASE_URL, CPR_BASE_AZURE_URL, FAF_BASE_AZURE_URL, SALESFORCE_BASE_URL, SUPERTOKEN_BASE_URL, CASE_BASE_AZURE_URL, SF_CASE_BASE_AZURE_URL } from "../constant/Constants";
import { akValue } from "./akValue";

// Function to make api calls using axios
export default async function axiosCall(
  method, //GET, POST, PUT, DELETE method
  url, // endpoint of the request
  headers = null,
  params = null, //query parameters to be passed in the request
  data = null,
  program) { //request body

  // Encrypting data
  if (IS_DATA_ENCRYPTED) {
    let API_PARAMS = ''
    if (program == 'PARTNER') {
      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(PARTNER_AK_VALUE.value)) : '';
      data = typeof data != 'undefined' ? encrypt(data, await akValue(PARTNER_AK_VALUE.value)) : '';
      url = params == null ? BASE_AZURE_URL + url : BASE_AZURE_URL + url + `param=${API_PARAMS}`;
      params = null;

    } else if (program == 'CPR') {

      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(CPR_AK_VALUE.value)) : '';
      data = typeof data != 'undefined' ? encrypt(data, await akValue(CPR_AK_VALUE.value)) : '';
      url = params == null ? CPR_BASE_AZURE_URL + url : CPR_BASE_AZURE_URL + url + `param=${API_PARAMS}`;
      params = null;

    } else if (program == 'FAF') {

      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(FAF_AK_VALUE.value)) : '';
      data = typeof data != 'undefined' ? encrypt(data, await akValue(FAF_AK_VALUE.value)) : '';
      url = params == null ? FAF_BASE_AZURE_URL + url : FAF_BASE_AZURE_URL + url + `param=${API_PARAMS}`;
      params = null;

    } else if (program == 'salesforce') {
      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(FAF_AK_VALUE.value)) : '';
      params = null;
      data = typeof data != 'undefined' ? encrypt(data, await akValue(FAF_AK_VALUE.value)) : '';
      url = SALESFORCE_BASE_URL + url + `params=${API_PARAMS}`;
    } else if (program == 'salesforceParam') {
      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(PARTNER_AK_VALUE.value)) : '';
      params = null;
      data = typeof data != 'undefined' ? encrypt(data, await akValue(PARTNER_AK_VALUE.value)) : '';
      url = SALESFORCE_BASE_URL + url + `params=${API_PARAMS}`;

    } else if (program == 'email') {
      url = url;
      params = null;
    } else if (program == 'ERDParam') {
      url = url + params;
      params = null;
    } else if (program == 'supertoken') {
      url = params == null ? SUPERTOKEN_BASE_URL + url : SUPERTOKEN_BASE_URL + url + params;
      params = null;
    } else if (program == "CM") {
      // url = params == null ? CASE_BASE_AZURE_URL + url : CASE_BASE_AZURE_URL + url + params;
      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(PARTNER_AK_VALUE.value)) : '';
      data = typeof data != 'undefined' ? encrypt(data, await akValue(PARTNER_AK_VALUE.value)) : '';
      url = params == null ? CASE_BASE_AZURE_URL + url : CASE_BASE_AZURE_URL + url + `param=${API_PARAMS}`;
      params = null;
      params = null;
    } else if (program == "partner_cm_pega") {
      API_PARAMS = typeof params != 'undefined' ? encrypt(params, await akValue(PARTNER_AK_VALUE.value)) : '';
      data = typeof data != 'undefined' ? encrypt(data, await akValue(PARTNER_AK_VALUE.value)) : '';
      url = params == null ? SF_CASE_BASE_AZURE_URL + url : SF_CASE_BASE_AZURE_URL + url + `param=${API_PARAMS}`;
      params = null;
    }
  } else {
    if (program == 'PARTNER') {

      url = params == null ? BASE_URL + url : BASE_URL + url + params;
      params = null;

    } else if (program == 'CPR') {
      url = params == null ? CPR_BASE_URL + url : CPR_BASE_URL + url + params;
      params = null;

    } else if (program == 'FAF') {
      url = params == null ? FAF_BASE_URL + url : FAF_BASE_URL + url + params;
      params = null;

    } else if (program == 'salesforce') {
      url = SALESFORCE_BASE_URL + url;
      params = null;
    } else if (program == 'salesforceParam') {
      url = SALESFORCE_BASE_URL + url + params;
      params = null;
    } else if (program == 'email') {
      url = url;
      params = null;
    } else if (program == 'ERDParam') {
      url = url + params;
      params = null;
    }
    else if (program == 'supertoken') {
      url = params == null ? SUPERTOKEN_BASE_URL + url : SUPERTOKEN_BASE_URL + url + params;
      params = null;
    } else if (program == "CM") {
      url = params == null ? CASE_BASE_AZURE_URL + url : CASE_BASE_AZURE_URL + url + params;
      params = null;
    } else if (program == "partner_cm_pega") {
      url = params == null ? SF_CASE_BASE_AZURE_URL + url : SF_CASE_BASE_AZURE_URL + url + params;
      params = null;
    }
  }

  const response = await axios({
    method,
    url,
    headers,
    params,
    data
  });

  // Decrypting the value if the Encryption is enabled
  let resData = null

  if (IS_DATA_ENCRYPTED) {

    if (program == 'PARTNER') {

      resData = response.data != "y8O3cVfegkjuquU5DfaX6w==" ? JSON.parse(decrypt(response.data, await akValue(PARTNER_AK_VALUE.value))) : ""
      resData = { ...response, ...{ data: resData } }

    } else if (program == 'CPR') {

      resData = response.data != "y8O3cVfegkjuquU5DfaX6w==" ? JSON.parse(decrypt(response.data, await akValue(CPR_AK_VALUE.value))) : ""
      resData = { ...response, ...{ data: resData } }

    } else if (program == 'FAF') {

      resData = response.data != "y8O3cVfegkjuquU5DfaX6w==" ? JSON.parse(decrypt(response.data, await akValue(FAF_AK_VALUE.value))) : ""
      resData = { ...response, ...{ data: resData } }

    } else if (program == 'salesforce') {
      resData = JSON.parse(decrypt(response, await akValue(PARTNER_AK_VALUE.value)));

    } else if (program == 'salesforceParam') {
      resData = JSON.parse(decrypt(response, await akValue(PARTNER_AK_VALUE.value)));
    } else if (program == 'email') {
      resData = response;
    } else if (program == 'ERDParam') {
      resData = response;
    } else if (program == 'supertoken') {
      resData = response;
    } else if (program == "CM") {
      resData = response.data != "y8O3cVfegkjuquU5DfaX6w==" ? JSON.parse(decrypt(response.data, await akValue(PARTNER_AK_VALUE.value))) : ""
      resData = { ...response, ...{ data: resData } }
    } else if (program == "partner_cm_pega") {
      resData = response.data != "y8O3cVfegkjuquU5DfaX6w==" ? JSON.parse(decrypt(response.data, await akValue(PARTNER_AK_VALUE.value))) : ""
      resData = { ...response, ...{ data: resData } }
    }
  } else {
    resData = response;
  }

  return resData;
}
